import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const { Users_Batch_Actions_Status_Endpoints } = Configuration

const resetState = {
  pageNumber: 0,
  activeFilters: {},
  activeSearch: '',
  activeSort: {},
  updatedItem: {},
}

export const usersBatchActionsStatusResetAlertHandler = createAsyncThunk(
  'usersBatchActionsStatus/usersBatchActionsStatusResetAlertHandler',
  async () => ({}),
)

export const getUsersBatchActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/getUsersBatchActionsStatusList',
  async ({ queries, resetQueries }, { getState, rejectWithValue }) => {
    const apiUri = Users_Batch_Actions_Status_Endpoints();
    const { usersBatchActionsStatus } = getState()
    const endpoint = apiUri.Batch_Actions_Status_list;
    const queryString =
      createReqHelper(usersBatchActionsStatus, resetQueries ? resetState : queries)

    const response = await RestClient.getRequest(`${endpoint}?${queryString}`);

    if (response.status >= 300) {
      return rejectWithValue(response);
    }

    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    };
  },
);

export const changeStatusProcessActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/changeStatusProcessActionsStatusList',
  async ({ queries }, { rejectWithValue, getState }) => {
    const { language } = getState()
    const apiUri = Users_Batch_Actions_Status_Endpoints(queries)
    const endpoint = apiUri.Batch_Actions_Status_ChangeStatusProcess;
    const response = await RestClient.putRequest(`${endpoint}`, {})

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      status: 201,
      severity: 'success',
      message: language?.translations?.['Status has been changed successfully'],
    }
  },
)

export const getUsersBatchActionsStatusListRefreshBtn = createAsyncThunk(
  'usersBatchActionsStatus/getUsersBatchActionsStatusListRefreshBtn',
  async (_, { rejectWithValue, getState }) => {
    const { usersBatchActionsStatus } = getState()
    const apiUri = Users_Batch_Actions_Status_Endpoints()
    const endpoint = apiUri.Batch_Actions_Status_list;
    const filters = createReqHelper(usersBatchActionsStatus, {})

    const response = await RestClient.getRequest(`${endpoint}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const getFilterUsersBatchActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/getFilterUsersBatchActionsStatusList',
  async ({ queries }, { rejectWithValue, getState }) => {
    const { usersBatchActionsStatus } = getState()
    const apiUri = Users_Batch_Actions_Status_Endpoints()
    const endpoint = apiUri.Batch_Actions_Status_list;

    let newFilterObj = { ...usersBatchActionsStatus?.activeFilters }

    if (queries === 'clear') {
      newFilterObj = {
        status: [],
        types: [],
      }
    } else if ('status' in queries || 'types' in queries) {
      newFilterObj = queries
    } else {
      newFilterObj = removeFilterIfExist(usersBatchActionsStatus?.filterList, queries, newFilterObj)
    }

    const filters = createReqHelper(usersBatchActionsStatus, { activeFilters: newFilterObj })

    const response = await RestClient.getRequest(`${endpoint}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      filters: newFilterObj,
    }
  },
)

function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters };

  const activeFilters = copyStore.activeFilters || {};
  const getFilterIds = (filtersId) => (filtersId || []).map((filter) => filter.id)

  const filterStatusIds = getFilterIds(activeFilters?.status).join('&statusIds=')
  const filterTypeIds = getFilterIds(activeFilters?.types).join('&typeIds=')

  const {
    pageSize,
    pageNumber,
    activeSort,
  } = copyStore;

  return [
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize || 9}`,
    `sort_by=${activeSort?.key || ''}`,
    `status_ids=${filterStatusIds}`,
    `type_ids=${filterTypeIds}`,
  ].join('&');
}

function removeFilterIfExist(filterListObj, queries, activeFilters) {
  if (filterListObj?.status?.some((e) => e.name === queries.name) === true) {
    activeFilters.status = activeFilters?.status?.filter((status) => status.id !== queries.id)
  }
  if (filterListObj?.types?.some((e) => e.name === queries.name) === true) {
    activeFilters.types = activeFilters?.types?.filter((type) => type.id !== queries.id)
  }
  return activeFilters
}
